import { Injectable } from '@angular/core';
import { QUOTE_STEPS } from './workflow.model';

@Injectable()
export class WorkflowService {
  public workflow = [
    { step: QUOTE_STEPS.registrationStartPage, valid: false },
    { step: QUOTE_STEPS.accountInfoPage, valid: false },
    { step: QUOTE_STEPS.registrationConfirmationPage, valid: false },
  ];

  validateStep(step: string) {
    // if the state is found, set the valid field to true
    const found = this.workflow.find(ele => ele.step === step);
    if (found) {
      found.valid = true;
    }
  }

  validateSteps(steps: Array<string>) {
    for (const step of steps) {
      this.validateStep(step);
    }
  }

  /**
   * returns the first invalid step up to the passed in step.
   * returns null if all the steps are valid up to the passed in
   * step
   */
  getFirstInvalidStep(step: string): string | null {
    for (let i = 0; i < this.workflow.length; i += 1) {
      const currentStep = this.workflow[i];

      console.log('step', currentStep.step, step);

      if (currentStep.step === step) {
        return null;
      }

      console.log('isvalid', currentStep.valid);
      if (!currentStep.valid) {
        return currentStep.step;
      }
    }
  }
}
